// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryItem_category__UunOD","subCategory":"CategoryItem_subCategory___aVPn","articles":"CategoryItem_articles__dkae3"};